import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import SubNavigationItems from "go-app/components/Navigation/SubNavigationItems";
import { hasRole } from "../../../../../services/users/selectors";

const AdminReportsNavigation = (props: RouteComponentProps) => {
	const { t } = useTranslation("admin");
	const prefixUrl = "/admin/reports";
	const hasAdminRole = useSelector(hasRole("ADMIN"));
	const hasOfficeRole = useSelector(hasRole("OFFICE"));
	const hasItSupportRole = useSelector(hasRole("IT_SUPPORT"));
	const hasSupportRole = useSelector(hasRole("SUPPORT"));
	const hasSaleTlRole = useSelector(hasRole("SALE_TL"));
	const hasCsTlRole = useSelector(hasRole("CS_TL"));
	const hasCsvTlRole = useSelector(hasRole("CSV_TL"));

	const items = [
		{
			title: "KPI",
			route: `${prefixUrl}/combo_reports`,
			hide: !(hasAdminRole || hasOfficeRole || hasSaleTlRole || hasCsTlRole),
		},
		{
			title: t("modules.organization_report.header.title"),
			route: `${prefixUrl}/organization_report`,
			hide: !(hasAdminRole || hasOfficeRole || hasSaleTlRole || hasCsTlRole),
		},
		{
			title: t("modules.transaction_report.header.title"),
			route: `${prefixUrl}/transactions_report`,
			hide: !(hasAdminRole || hasOfficeRole || hasSaleTlRole || hasCsTlRole),
		},
		{
			title: "Raport funkcji",
			route: `${prefixUrl}/organization_feature_report`,
			hide: !(hasAdminRole || hasOfficeRole || hasSaleTlRole || hasCsTlRole || hasCsvTlRole),
		},
		{
			title: "Raport funkcji - użycie",
			route: `${prefixUrl}/organization_feature_usage_report`,
			hide: !(hasAdminRole || hasOfficeRole || hasSaleTlRole || hasCsTlRole || hasCsvTlRole),
		},
		{
			title: t("modules.partner_report.header.title"),
			route: `${prefixUrl}/partner_report`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.company_report.header.title"),
			route: `${prefixUrl}/companies_report`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.device_report.header.title"),
			route: `${prefixUrl}/devices_report`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.access.report.header.title"),
			route: `${prefixUrl}/accesses_report`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
		{
			title: t("modules.terminal_report.header.title"),
			route: `${prefixUrl}/terminals_report`,
			hide: !(hasAdminRole || hasOfficeRole),
		},
	];

	return <SubNavigationItems title={t("modules.admin.header.title")} items={items} />;
};

export default AdminReportsNavigation;
